"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.jumpNavigationPage = exports.closeCurrentPage = exports.setTitle = exports.appPickCamera = exports.newWebView = exports.scan = exports.changeInitalUrl = exports.updateBadgeCount = exports.getStatusBarHeight = exports.showStatusBar = exports.logout = exports.loginExpires = exports.downloadFile = exports.getLocation = exports.pickCamera = exports.pickImage = exports.pickContact = exports.getContacts = void 0;

var _bridge = require("./bridge");

function createApi(apiName, hasParams) {
  return function () {
    if (_bridge.isNative) {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var params = hasParams ? args.shift() : {};
      var successCallback = args[0],
          failCallback = args[1];
      return _bridge.JsBridge.getInstance().invoke(apiName, params, successCallback, failCallback);
    }
  };
} // createApi 第二个参数表示是否带有参数


var getContacts = createApi('getContact');
exports.getContacts = getContacts;
var pickContact = createApi('pickContact');
exports.pickContact = pickContact;
var pickImage = createApi('pickImage');
exports.pickImage = pickImage;
var pickCamera = createApi('pickCamera');
exports.pickCamera = pickCamera;
var getLocation = createApi('getLocation');
exports.getLocation = getLocation;
var downloadFile = createApi('download', true);
exports.downloadFile = downloadFile;
var loginExpires = createApi('requireLogin');
exports.loginExpires = loginExpires;
var logout = createApi('exitLogin');
exports.logout = logout;
var showStatusBar = createApi('showStatusBar', true);
exports.showStatusBar = showStatusBar;
var getStatusBarHeight = createApi('getStatusBarHeight'); // 更新图标冒泡提示

exports.getStatusBarHeight = getStatusBarHeight;
var updateBadgeCount = createApi('updateBadgeCount', true); // 改变webview的initnalUrl

exports.updateBadgeCount = updateBadgeCount;
var changeInitalUrl = createApi('changeInitalUrl', true); // 扫一扫

exports.changeInitalUrl = changeInitalUrl;
var scan = createApi('scan'); // 新增一个webview页面

exports.scan = scan;
var newWebView = createApi('newWebView', true); // 拍照上传 app上传，接受传入参数

exports.newWebView = newWebView;
var appPickCamera = createApi('appPickCamera', true); // 新的webview页面，设置title

exports.appPickCamera = appPickCamera;
var setTitle = createApi('setTitle', true); // 关闭当前webview页面（对应钉钉的closeApp）

exports.setTitle = setTitle;
var closeCurrentPage = createApi('closeCurrentPage'); // 跳转回flutter的原生页面

exports.closeCurrentPage = closeCurrentPage;
var jumpNavigationPage = createApi('jumpNavigationPage', true);
exports.jumpNavigationPage = jumpNavigationPage;